import { defineMessages } from 'react-intl';

const translations = {
  subNavigation: {
    outbound: {
      id: 'pages.shipments.subNavigation.outbound',
      defaultMessage: 'Outbound',
      description: 'title of the outbound navigation tab on the shipments page',
    },
    inbound: {
      id: 'pages.shipments.subNavigation.inbound',
      defaultMessage: 'Inbound',
      description: 'title of the inbound navigation tab on the shipments page',
    },
  },
  secondaryActions: {
    switchLocations: {
      id: 'pages.shipments.secondaryActions.switchLocations',
      defaultMessage: 'Switch locations',
      description: 'Label of the switch locations action on the shipments page',
    },
  },
  title: {
    id: 'pages.shipments.title',
    defaultMessage: 'Shipments',
    description: 'title of the shipments page',
  },
  create: {
    button: {
      id: 'pages.shipments.create.button',
      defaultMessage: 'Create',
      description: 'Label of the create button on the shipments page',
    },
  },
  emptyMessage: {
    id: 'pages.shipments.emptyMessage',
    defaultMessage: 'No shipments',
    description: 'Empty message of the data list on the shipments page',
  },
  statusses: {
    open: {
      id: 'shipmentStatusses.open',
      defaultMessage: 'Open',
      description: 'Label of the open status on the shipments page',
    },
    finished: {
      id: 'shipmentStatusses.finished',
      defaultMessage: 'Finished',
      description: 'Label of the finished status on the shipments page',
    },
    inTransit: {
      id: 'shipmentStatusses.inTransit',
      defaultMessage: 'In transit',
      description: 'Label of the in transit status on the shipments page',
    },
  },
};

export default defineMessages(translations);
